module.exports = __webpack_public_path__ + "static/img/shipinghao.d54b1deb.jpg";